import Logo from "./logo.png"
import Banner1 from "./Banner/BannerOne.png"
import Banner2 from "./Banner/BannerTwo.png"
import ServiceOne from "./services/services1.png"
import ServiceTwo from "./services/services2.png"
import ServiceThree from "./services/services3.png"
import ServiceFour from "./services/services4.png"
import ServiceFive from "./services/services5.jpg"
import ServicesSix from "./services/services6.jpg"
import ServiceSeven from "./services/services7.jpg"
import ExpertOne from "./Experts/Experts1.jpg"
import ExpertTwo from "./Experts/Experts2.jpg"
import ExpertThree from "./Experts/Experts3.jpg"
import ExpertFour from "./Experts/Experts4.jpg"
import ExpertFive from "./Experts/Experts5.jpg"
import ExpertSix from "./Experts/Experts6.jpg"
import ChooseOne from "./WhyChoose/choose1.png"
import ChooseTwo from "./WhyChoose/choose2.png"
import ChooseThree from "./WhyChoose/choose3.png"
import ChooseFour from "./WhyChoose/choose4.png"
import ChooseFive from "./WhyChoose/choose5.png"
import Testimonial from "./testimonial.png"
import FaceBook from "./Facebook.png"
import Instagram from "./Instagram.png"
import BlogOne from "./Blog/Blog1.png"
import BlogTwo from "./Blog/Blog2.png"
import BlogThree from "./Blog/Blog3.png"
import BlogFour from "./Blog/Blog4.png"
import BlogFive from "./Blog/blog5.png"
import BlogSix from "./Blog/blog6.png"
import InstagramFooter from "./instagramFooter.png"
import FaceBookFooter from "./facebookFooter.png"
import AboutBanner from "./AboutPage/about.png"
import FounderImg from "./AboutPage/founderImg.png"
import ChairmanImg from "./AboutPage/chairmanImg.png"
import DirectorImg from "./AboutPage/directorImg.png"
import FacilityOne from "./VisionAndMission/facility1.png"
import FacilityTwo from "./VisionAndMission/facility2.png"
import FacilityThree from "./VisionAndMission/facility3.png"
import FacilityFour from "./VisionAndMission/facility4.png"
import FacilityFive from "./VisionAndMission/facility5.png"
import ServiceDetailBanner from "./services/service-detail-banner.png"
import DoctorDetailBanner from "./DoctorDetail.jpg"
import AppointmentImage from "./images/appointment-image.png"
import InstaShare from "./Blog/instashare.png"
import FacebookShare from "./Blog/facebookShare.png"
import TwitterShare from "./Blog/twitterShare.png"
import ContactPageBanner from "./images/contactPage.png"
import AyushmanBanner from "./images/AyushmanBanner.png"
import AyushmanLogo from "./images/ayushmanLogo.png"
import AyushmanPhoto from "./images/ayushmanphoto.png"
import CareerBanner from "./Career/CareerBanner.jpg"
import CareerPageDoctorImage from "./Career/CareerPageDoctor.png"
import CareerOpeningOne from "./Career/opening1.jpg"
import CareerOpeningTwo from "./Career/opening2.jpg"
import JobOpeningCheckIcon from "./Career/check.png"
import NotFoundImg from "./not-found.png"


export const images = {
    Logo,
    Banner1,
    Banner2,
    ServiceOne,
    ServiceTwo,
    ServiceThree,
    ServiceFour,
    ServiceFive,
    ServicesSix,
    ServiceSeven,
    ExpertOne,
    ExpertTwo,
    ExpertThree,
    ExpertFour,
    ExpertFive,
    ExpertSix,
    ChooseThree,
    ChooseOne,
    ChooseTwo,
    ChooseFour,
    ChooseFive,
    Testimonial,
    FaceBook,
    Instagram,
    BlogOne,
    BlogTwo,
    BlogThree,
    BlogFour,
    BlogFive,
    BlogSix,
    InstagramFooter,
    FaceBookFooter,
    AboutBanner,
    FounderImg,
    ChairmanImg,
    DirectorImg,
    FacilityOne,
    FacilityThree,
    FacilityTwo,
    FacilityFour,
    FacilityFive,
    ServiceDetailBanner,
    DoctorDetailBanner,
    AppointmentImage,
    InstaShare,
    TwitterShare,
    FacebookShare,
    ContactPageBanner,
    AyushmanBanner,
    AyushmanLogo,
    AyushmanPhoto,
    CareerBanner,
    CareerPageDoctorImage,
    CareerOpeningOne,
    CareerOpeningTwo,
    JobOpeningCheckIcon,
    NotFoundImg
}